module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/TemperatureMin/Tokyo_TemperatureMin_MRI_RCP85_End.png";